import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { i18nReady } from '@/i18n/config';
import './styles/globals.css';
import { registerFirebaseMessagingSW, setupServiceWorkerUpdateListeners } from './lib/serviceWorkerManager';

// Register Firebase Messaging service worker early
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  setupServiceWorkerUpdateListeners();

  registerFirebaseMessagingSW().then((registration) => {
    if (registration) {
      console.log('Firebase Messaging SW registered on app start');
    }
  }).catch((error) => {
    console.error('Error registering Firebase Messaging SW:', error);
  });
}

// Wait for the initial locale chunk to load before mounting React so the first render
// has translations available. The chunk is small (~75 KB for English, ~120 KB for Greek)
// and loads in parallel with the rest of the boot work.
void i18nReady.finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
});
